export const PERSONALITY = {
    section: 'personalities-section',
    card: 'personality-card',
    name: 'personality-name',
    tagline: 'personality-tagline',
    groupInsight: 'personality-group-insight',
    refreshButton: 'personality-refresh-button',
};

export const VOTING = {
    inlineButtons: 'vote-buttons-inline',
    mustButton: 'vote-must-button',
    niceButton: 'vote-nice-button',
    skipButton: 'vote-skip-button',
    breakdown: 'vote-breakdown',
    score: 'vote-score',
};

export const VOTES_TAB = {
    container: 'votes-tab-container',
    tierFilter: 'votes-tier-filter',
    sortSelect: 'votes-sort-select',
    tierSectionTier1: 'votes-tier-1',
    tierSectionTier2: 'votes-tier-2',
    tierSectionTier3: 'votes-tier-3',
    rankedItem: 'votes-ranked-item',
    empty: 'votes-empty',
};
